<template>
  <UiTooltip
    ref="tooltip"
    :placement="placement"
    :tooltip-class="tooltipClass"
    :transition="transition"
    :other-toggle="otherToggle"
  >
    <slot />
  </UiTooltip>
</template>

<script lang="ts" setup>
import type { Placement } from '@popperjs/core'
import type { UiTooltip } from '#components'

interface Props {
  placement?: Placement
  tooltipClass?: string
  transition?: string
  otherToggle?: HTMLElement
}
const props = withDefaults(defineProps<Props>(), {
})

const tooltip = ref<InstanceType<typeof UiTooltip>>()
const toggle = () => {
  tooltip.value.toggle()
}
defineExpose({ toggle })
</script>

<style lang="scss" scoped>
</style>
